<template>
  <header class="the-header">
    <YContainer>
      <div class="the-header__wrapper">
        <div class="the-header__brand">
          <TheHeaderBrand />
        </div>

        <div class="the-header__content">
          <ul class="the-header__nav">
            <li
              v-for="link in links"
              :key="link.href"
              class="the-header__nav-item"
            >
              <z-button
                tag="a"
                :href="link.href"
                variant="tertiary"
              >
                {{ link.text }}
              </z-button>
            </li>
          </ul>
        </div>

        <div class="the-header__action-list">
          <TheHeaderMenuMobile
            class="the-header__menu-mobile"
            :items="links"
          />
          <TheHeaderHelpPopover class="the-header__help-center" />
        </div>
      </div>
    </YContainer>
  </header>
</template>

<script>
import { YContainer } from '@quero/yeti'

import TheHeaderHelpPopover from './the-header-help-popover'
import TheHeaderMenuMobile from './the-header-menu-mobile'
import TheHeaderBrand from './the-header-brand.vue'

export default {
  name: 'TheHeader',
  components: {
    YContainer,
    TheHeaderBrand,
    TheHeaderHelpPopover,
    TheHeaderMenuMobile,
  },
  data () {
    return {
      links: [{
        text: 'Faculdades',
        href: 'https://querobolsa.com.br/faculdades-e-universidades',
      }, {
        text: 'Cursos',
        href: 'https://querobolsa.com.br/cursos-e-faculdades',
      }, {
        text: 'Profissões',
        href: 'https://querobolsa.com.br/carreiras-e-profissoes/todas',
      }, {
        text: 'Revista',
        href: 'https://querobolsa.com.br/revista',
      }, {
        text: 'Ajuda',
        href: 'https://querobolsa.com.br/central-de-ajuda',
      }],
    }
  },
}
</script>

<style lang="scss" scoped>
.the-header {
  background-color: var(--color-white);
}

.the-header__wrapper {
  --the-header-height: var(--unit-1600);

  align-items: center;
  column-gap: var(--unit-0200);
  display: grid;
  grid-template-areas: 'brand action-list';
  grid-template-columns: 1fr max-content;
  grid-template-rows: 1fr;
  height: var(--the-header-height);
  row-gap: var(--unit-0400);

  @media (max-width: $breakpoint-phone) {
    padding-left: var(--unit-0200);
    padding-right: var(--unit-0200);
  }

  @media (min-width: $breakpoint-desktop) {
    --the-header-height: var(--unit-2000);

    grid-template-areas: 'brand content action-list';
    grid-template-columns: max-content auto min-content;
    grid-template-rows: 1fr;
  }
}

.the-header__brand {
  grid-area: brand;
  width: 123px;

  @media (min-width: $breakpoint-desktop) {
    margin-right: var(--unit-0400);
    width: 162px;
  }
}

.the-header__content {
  display: none;
  grid-area: content;

  @media (min-width: $breakpoint-desktop) {
    display: block;
  }
}

.the-header__action-list {
  align-items: center;
  display: flex;
  grid-area: action-list;
  justify-self: start;
}

.the-header__nav {
  display: inline-flex;
  list-style: none;
  margin: 0;
  padding-left: 0;
}

.the-header__nav-item {
  & + & {
    margin-top: var(--unit-0200);

    @media (min-width: $breakpoint-desktop) {
      margin-left: var(--unit-0200);
      margin-top: 0;
    }
  }
}

.the-header__help-center {
  display: none;
  margin-left: var(--unit-0200);

  @media (min-width: $breakpoint-desktop) {
    display: block;
  }
}

.the-header__menu-mobile {
  @media (min-width: $breakpoint-desktop) {
    display: none;
  }
}
</style>
